import { h, Component } from 'preact';
import Store from 'store/store';
import 'store/bolt/signUpBanner';
import HTML from 'components/core/html/html';
import Newsletter from 'components/bolt/icons/newsletter';
import Close from 'components/bolt/icons/close';
import { joinClasses, accessNested } from 'utils/utils';
import { getRelativePageUrl, navigateInternally } from 'utils/bolt';
import { oneTrust } from 'utils/gdpr';
import * as categories from 'utils/gdpr/categories';

import s from 'components/bolt/signUpForm/signUpForm.sss';
import cc from 'components/bolt/signUpForm/constantContact.sss';

import { getCopy } from 'utils/copy';

class SignUpForm extends Component {
	constructor(props) {
		super(props);
		const store = Store.get();
		this.formType = accessNested(store, 'appData.options.formEmbeds.signUp.formType', {});
		this.useMailchimp = this.formType === 'mailchimp';
		this.url = this.props.data.embedCode || '';
		this.u = this.url.match(/u=[^&]+/) || [];
		this.id = this.url.match(/id=[^&]+/) || [];
		this.hasFormSubmit = this.useMailchimp && !!(this.url && this.u && this.id);
		this.useConstantContact = this.formType === 'constantContact';
		this.FormTag = this.useConstantContact ? 'div' : 'form';
		this.dataFormId = accessNested(store, 'appData.options.formEmbeds.signUp.embedCode', '').split(',')[1];
		this.usesEvidon = accessNested(store, 'appData.options.requireUserConsent');
		this.state = {
			legalCopyMaxWidth: null
		};
		this.closeBanner = this.closeBanner.bind(this);
		this.closeSubscribed = this.closeBanner.bind(this, 'subscribed');
		this.closeDismiss = this.closeBanner.bind(this, 'dismiss');
		this.getForm = this.getForm.bind(this);
		this.toggleBanner = this.toggleBanner.bind(this);
		this.searchForConstantContact = this.searchForConstantContact.bind(this);
		this.checkIfCanShowBanner = this.checkIfCanShowBanner.bind(this);
	}

	componentDidMount() {
		this.restrictLegalCopyWidth();
		this.checkIfCanShowBanner();
		this.searchForConstantContact();
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.clientData.deviceSize !== this.props.clientData.deviceSize) {
			this.restrictLegalCopyWidth();
		}
		if (
			(prevState.oneTrustAllowed !== this.state.oneTrustAllowed) ||
			(prevProps.cookies !== this.props.cookies) ||
			(prevProps.externalCookieBanner !== this.props.externalCookieBanner) ||
			(prevProps.activePage !== this.props.activePage)
		) {
			this.checkIfCanShowBanner();
		}
		// TODO: Move to Bolt utils
		const signUpForm = document.querySelector('#signUpForm');
		const signUpFormHeight = getComputedStyle(signUpForm).height;
		const signUpFormHeightFormat = parseInt(signUpFormHeight, 10);
		Store.get().client.set({ signUpFormHeight: signUpFormHeightFormat });
	}
	componentWillUnmount() {
		window.clearInterval(this.ccInterval);
		window.clearTimeout(this.ccTimeout);
		window.clearTimeout(this.ccSuccessTimeout);
	}

	searchForConstantContact() {
		if (accessNested(Store.get(), 'appData.options.formEmbeds.signUp.formType', '') !== 'constantContact') {
			return;
		}

		this.ccInterval = window.setInterval(() => {
			// Look for the success message on the page. Listen for a styling change.
			// If it changes from 'display: none' to 'display: block', form was successfully submitted
			const ccSuccessMessage = document.getElementById('success_message_1'); // Not sure if this will be the same for every form, check here first if any issue with Constant Contact
			if (ccSuccessMessage) {
				window.clearInterval(this.ccInterval);

				const observer = new MutationObserver((mutationList) => {
					for (const mutation of mutationList) {
						if (mutation.type === 'attributes' && getComputedStyle(ccSuccessMessage).display !== 'none') {
							this.ccSuccessTimeout = window.setTimeout(this.closeSubscribed, 5000);
						}
					}
				});

				observer.observe(ccSuccessMessage, { attributes: true });
			}
		}, 200);

		this.ccTimeout = window.setTimeout(() => {
			// if not found after 10 seconds, give up
			window.clearInterval(this.ccInterval);
		}, 10000);
	}

	checkIfCanShowBanner() {
		if (this.userDismissed) return;
		// We need to show the signup banner once the user has dismissed the cookie banner (doesn't matter if they've accepted or not)
		if (!window.powsterOneTrust) return;
		// check if user has previously closed or subscribed
		if (this.hasHideBannerCookie()) {
			return;
		}
		// Exclude from certain pages or if the button is linking to this page
		const store = Store.get();
		const { data } = this.props;
		const pageExclusions = (data?.pageExclusions || '').split(',').map(a => a.trim()).filter(a => a);
		const activePage = store.activePage;
		const bannerButtonLink = data?.button?.href;

		if ((activePage && (activePage === bannerButtonLink || pageExclusions.includes(activePage)))) {
			if (store.signupBanner?.open) {
				Store.emit('TOGGLE_NEWSLETTER_BANNER', true);
			}
			return;
		}

		const delayMs = (this.props.data.bannerDelay || 0) * 1000;

		setTimeout(() => {
			if (this.userDismissed) return;
			Store.emit('TOGGLE_NEWSLETTER_BANNER', false);
		}, delayMs);
	}

	setCookie(daysToLive) {
		const store = Store.get();
		const usesOneTrust = accessNested(store, 'appData.options.oneTrustCookieConsent');
		const usesPowCookieBanner = accessNested(store, 'appData.options.cookiesModal.enableModal');

		if (usesPowCookieBanner && !categories.has('FUNCTIONAL')) {
			return;
		}

		const { oneTrustAllowed } = this.state;
		if (usesOneTrust && !oneTrustAllowed) {
			return;
		}

		document.cookie = `hideSignupBanner=true; max-age=${daysToLive * 24 * 60 * 60}`;
	}

	hasHideBannerCookie() {
		return document.cookie.match(/hideSignupBanner=true/);
	}

	restrictLegalCopyWidth() {
		const isMobile = accessNested(this.props, 'clientData.deviceSize') === 'mobile';
		if (isMobile) {
			this.setState({ legalCopyMaxWidth: null });
		} else {
			if (!this.$inputContainer) return;
			const legalCopyMaxWidth = this.$heading.clientWidth + this.$inputContainer.clientWidth;
			this.setState({ legalCopyMaxWidth });
		}
	}

	closeBanner(reason, e) {
		// Some weird notes:
		// Setting state in here (the form's onSubmit function) makes the mailchimp form just open the action link without actually submitting the form data
		// If we absolutely must setState here, we can do ->
		// if (userSubscribed && e.target && typeof e.target.submit === 'function') {
		// 	e.preventDefault();
		// 	e.target.submit();
		// }
		// which fixes it in Chrome, but not Safari
		const userSubscribed = reason === 'subscribed';
		if (accessNested(Store.get(), 'signupBanner.open')) {
			this.toggleBanner();
			this.userDismissed = true;
			const daysToLive = this.props.data?.cookieExpiration?.[userSubscribed ? 'userSubscribed' : 'bannerDismissed'] || (userSubscribed ? 183 : 1);
			this.setCookie(+daysToLive);
		}
	}

	toggleBanner() {
		Store.emit('TOGGLE_NEWSLETTER_BANNER');
	}

	renderCloseButton(className) {
		return (
			<button class={className} onClick={this.closeDismiss} type="button" ariaLabel={this.props.data.closeBtnAriaLabel || 'Close banner'}>
				<Close />
			</button>
		);
	}
	getForm() {
		if (this.useConstantContact) {
			return <div class={joinClasses(cc.ctctForm, 'ctct-inline-form')} data-form-id={this.dataFormId} />;
		}

		let submitBtn;
		const { data } = this.props;
		const btnData = data.button || {};
		let u = this.u[0]?.replace('u=', '');
		let id = this.id[0]?.replace('id=', '');

		if (this.hasFormSubmit && (!u || !id)) {
			console.log('Incorrect submit link for mailchimp!');
		}

		if (this.hasFormSubmit) {
			submitBtn = (
				<input
					type="submit"
					class={joinClasses(s.button, s.submitFormBtn)}
					value={getCopy(btnData.label) || btnData.label}
					name="subscribe"
					ariaLabel={getCopy(btnData.ariaLabel) || btnData.ariaLabel}
				/>
			);
		} else {
			let href = btnData.href;
			let onClick = this.closeSubscribed;
			let target = '_blank';
			const store = Store.get();
			let page = store.appData?.pages?.[href];
			if (page) {
				href = getRelativePageUrl(page);
				target = undefined;
				onClick = e => {
					e.preventDefault();
					navigateInternally(btnData.href);
					this.closeSubscribed(e);
				};
			}
			submitBtn = (
				<a
					class={s.button}
					href={href}
					target={target}
					ariaLabel={getCopy(btnData.ariaLabel) || btnData.ariaLabel}
					onClick={onClick}
				>
					{getCopy(btnData.label) || btnData.label}
				</a>
			);
		}

		return (
			<div class={joinClasses(s.inputContainer, this.hasFormSubmit && s.emailInputContainer)} ref={ref => this.$inputContainer = ref}>
				{this.hasFormSubmit && <input type="email" class={s.email} value="" name="EMAIL" id="mce-EMAIL" placeholder={data.emailPlaceholder || 'Email address'} required />}
				{this.hasFormSubmit && <input type="text" class={s.antiBot} name={'b_' + u + '_' + id} tabindex="-1" value="" aria-hidden="true" />}
				{submitBtn}
			</div>
		);
	}

	render({ data }) {
		const open = accessNested(Store.get(), 'signupBanner.open');
		const { legalCopyMaxWidth } = this.state;
		const legalCopyContainerStyle = legalCopyMaxWidth ? { maxWidth: `${legalCopyMaxWidth}px` } : {};
		let FormTag = this.FormTag;
		const { navOpen, showtimesProviderInterstitialOpen } = this.props;
		const hideBanner = navOpen || showtimesProviderInterstitialOpen;

		return (
			<div id="signUpForm" class={joinClasses(s.formContainer, !open && s.closedBanner, hideBanner && s.hide)} >
				<FormTag
					class={joinClasses(s.form, this.hasFormSubmit && s.formWithEmail, this.useConstantContact && cc.ctctFormContainer)}
					onSubmit={!this.useConstantContact && this.closeSubscribed}
					action={this.url}
					method="post"
					name="mc-embedded-subscribe-form"
					target="_blank"
					novalidate
				>
					<div class={s.heading} ref={ref => this.$heading = ref}>
						<Newsletter class={s.newsletterIcon} aria-hidden />
						<div class={joinClasses(s.text, this.useConstantContact && cc.text)}>
							<HTML
								markdown
								class={s.title}
								content={data.title}
							/>
							{data.blurb && (
								<HTML
									markdown
									class={s.blurb}
									content={data.blurb}
								/>
							)}
						</div>
						{this.renderCloseButton(s.closeBtn)}
					</div>
					{this.getForm()}
					{this.renderCloseButton(joinClasses(s.closeBtn, s.wideScreenCloseBtn))}
				</FormTag>
				{(data.legalCopy && !this.useConstantContact) && (
					<div
						class={joinClasses(s.legalCopyContainer, this.hasFormSubmit && s.legalCopyWithForm)}
						style={legalCopyContainerStyle}
					>
						<HTML
							class={s.legalCopy}
							markdown
							content={data.legalCopy}
						/>
					</div>
				)}
			</div>
		);
	}
}

export default oneTrust.connectToOneTrust(oneTrust.FUNCTIONAL, SignUpForm);
